import React from 'react';
import TextFilter from 'components/list/Filters/types/TextFilter';

const EmailFilter = <TextFilter
    label='filters.components.email.label'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='email'
/>;

export default EmailFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/EmailFilter.js